<div class="popup g-popup" (cmsEscapeKey)="closePopup()">
    <header class="g-popup-header">
        <i (click)="closePopup()" class="g-popup-header-close g-icon g-icon-close-a"></i>
        <div class="g-popup-title">{{'menus_confirm_translation_delete_action' | translate}}</div>
    </header>
    <div class="g-popup-body">
        <div class="content">
            {{'menus_confirm_translation_delete' | translate}}
        </div>
        <div class="form-footer">
            <div class="form-footer-buttons">
                <button class="form-footer-button g-button g-button-earth"
                        type="submit"
                        (click)="closePopup()">
                    <span class="g-button-title">{{'common_cancel' | translate}}</span>
                </button>
                <button class="form-footer-button g-button g-button-earth"
                        type="submit"
                        (click)="deleteItem()">
                    <span class="g-button-title">{{'common_delete' | translate}}</span>
                </button>
            </div>
        </div>
    </div>
</div>